<template>
  <v-btn icon @click="download" :loading="loading"><v-icon>mdi-download</v-icon></v-btn>
</template>

<script>
import { downloadDay } from '@/api'
export default {
  props: ['dayId'],
  data () {
    return {
      loading: false
    }
  },
  methods: {
    async download () {
      if (this.loading) return
      this.loading = true
      const id = this.dayId
      try {
        console.log(id)
        const url = await downloadDay(id)
        console.log(url)
        const a = document.createElement('a')
        if (!a.click) {
          window.location = url
          return
        }
        a.setAttribute('href', url)
        a.style.display = 'none'
        document.body.appendChild(a)
        a.click()
      } catch (err) {
        alert(err.message)
      }
      this.loading = false
    }
  }
}
</script>
